import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios'
import { Logger, AppError, Flash } from 'app'

export class API {
    static api_root = `${process.env.REACT_APP_API_ROOT}`

    static request = async (method, url, data = {}, params = {}) => {
        Logger.log('SEND', `${method} ${url}`, { data, params })
        var response
        try {
            response = await axios({
                method, baseURL: API.api_root,
                url, data, params, withCredentials: true
            })
        } catch (err) { // Catches all non-OK responses
            const status = err.response.status
            var errorType = 'Error'
            if (Math.floor(status / 100) === 4) {
                errorType = 'Client error'
            } else if (Math.floor(status / 100) === 5) {
                errorType = 'Server error'
            }
            throw new AppError(`${errorType}: ${err.response.status} ${err.response.statusText}`, { err, method, url, data, params })
        }
        // Check if response data has status and is either success or error
        if (!(response.data.status && ((response.data.status == 'SUCCESS') || (response.data.status == 'ERROR')))) {
            throw new AppError(`Unknown error: ${JSON.stringify(response.data)}`, { method, url, data, params, response }, 'ERROR')
        } else if (response.data.status === 'SUCCESS') {
            Logger.log('RECV', `${method} ${url}`, response.data)
            return response.data.payload
        } else if (response.data.status === 'ERROR') {
            throw new AppError(`API error: ${response.data.message}`, { method, url, data, params, response }, 'APIERR')
        }
    }

    static endpoints = {
        INIT:                   { method: 'GET',    url: '/init' },
        AUTH_INIT:              { method: 'POST',   url: '/auth/init' },
        AUTH_RELOAD:            { method: 'GET',    url: '/auth/reload' },
        AUTH_LOGOUT:            { method: 'POST',   url: '/auth/logout' },
        ADMIN_VALIDATE_DATA:    { method: 'GET',    url: '/admin/validate_data' },
        USER_PROFILE_VIEW:      { method: 'GET',    url: '/user/profile/view' },
        COURSE_VIEW:            { method: 'GET',    url: '/course/view' },
        RESOURCE_VIEW:          { method: 'GET',    url: '/resource/view' },
        TESTSESSION_CREATE:     { method: 'POST',   url: '/testsession/create' },
        TESTSESSION_UPDATE:     { method: 'POST',   url: '/testsession/update' },
        TESTSESSION_SAVE:       { method: 'POST',   url: '/testsession/save' },
        TESTSESSION_VIEW:       { method: 'GET',    url: '/testsession/view' },
        SUBSCRIPTION_CREATE:    { method: 'POST',   url: '/subscription/create' },
        SUBSCRIPTION_VERIFY:    { method: 'POST',   url: '/subscription/verify' },
    }

    static useAPI = () => {
        const apiState = useSelector(state => state.api)
        const resolverRef = useRef(null)
        const rejecterRef = useRef(null)

        useEffect(() => {
            if (apiState.status === 'CONNECTED' && resolverRef.current) {
                resolverRef.current()
            } else if (apiState.status === 'DISCONNECTED' && rejecterRef.current) {
                rejecterRef.current(new AppError(`API init failed:\n ${apiState.errMessage}`))
            }
            resolverRef.current = null
            rejecterRef.current = null
          }, [apiState])
          
        const waitForInit = () => {
            if (apiState.status === 'CONNECTED') {
                return Promise.resolve()
            }
            if (apiState.status === 'DISCONNECTED') {
                console.log(apiState.errMessage)
                return Promise.reject(new AppError(`API init failed:\n ${apiState.errMessage}`))
            }
            return new Promise((resolve, reject) => {
                resolverRef.current = resolve
                rejecterRef.current = reject
            })
        }

        const callApi = async (endpoint, args={}, onError='flash_throw') => {
            try {
                const { method, url } = endpoint
                if (url != this.endpoints.INIT.url) {
                    await waitForInit()
                }
                if (method === 'GET') {
                    return await API.request(method, url, {}, args)
                } else if (method === 'POST') {
                    return await API.request(method, url, args, {},)
                } else {
                    throw new Error(`Unsupported method: ${method}`)
                }    
            } catch(err) {
                if (onError == 'flash_throw'){
                    Flash.add({type: 'ERROR', message: err.message })
                    throw err
                } else if (onError == 'flash'){
                    Flash.add({type: 'ERROR', message: err.message })
                } else {
                    throw err
                }
            }
        }

        return callApi
    }
}

